var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 12.6 14.64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4a4a4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6 7.34v6.95a.354.354 0 01-.35.35H8.07a.346.346 0 01-.34-.35v-3.52H4.94v3.52a.346.346 0 01-.34.35H.42a.394.394 0 01-.25-.1.394.394 0 01-.1-.25V7.34zM12.33 6.24a.178.178 0 01-.16.1h-12A.169.169 0 010 6.17a.135.135 0 01.05-.12S5.05.97 5.92.1a.347.347 0 01.25-.1.354.354 0 01.26.1l5.86 5.95a.168.168 0 01.04.19z"
  }))));
}
export default __webpack_public_path__ + "688d1c800fa05284abc739924f38f2e1.svg";
export { SvgHomeIcon as ReactComponent };